/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import { Route, Routes, BrowserRouter as Router, Navigate } from 'react-router-dom';
import { PrivateRoute } from 'components/common';
import { ConfigProvider } from 'antd';
import trTR from 'antd/lib/locale/tr_TR';
import 'moment/locale/tr';
import { AnnouncementProvider, BranchProvider } from './context';

import {
  Login,
  Dashboard,
  User,
  MyMerchs,
  MerchEdit,
  SubMerchs,
  Branch,
  // BranchAdd,
  Terminal,
  // TerminalAdd,
  EodReportByMerch,
  EodReportByBranchWrapper,
  EodReportByTerminalWrapper,
  MyInvoice,
  PayeInvoice,
  Payment,
  // CurrentAccount,
  // Babs,
  Role,
  Register,
  RegisterConfirm,
  ForgotPassword,
  Announcements,
  ConnectUs,
  UserInformation,
} from './views';
import BranchEdit from './views/Branch/BranchEdit';
import authorities from './helpers/authorities';
import TransactionsNotIncludedInvoice from './views/Reports/TransactionsNotIncludedInvoice/TransactionsNotIncludedInvoice';

class App extends React.Component {
  render() {
    return (
      <ConfigProvider locale={trTR}>
        <AnnouncementProvider>
          <BranchProvider>
            <Router>
              <Routes>
                <Route path="/" element={<Navigate to="/login" />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/bize-ulasin" element={<ConnectUs />} />
                <Route path="/register/hash" element={<RegisterConfirm />} />
                <Route
                  path="/dashboard"
                  element={
                    <PrivateRoute
                      component={Dashboard}
                      authorityCode={authorities.DISPLAY_DASHBOARD}
                    />
                  }
                />
                <Route
                  path="/kullanici-islemleri"
                  element={
                    <PrivateRoute
                      component={User}
                      authorityCode={authorities.DISPLAY_ALL_RECORDS_SUB_USERS}
                    />
                  }
                />
                <Route
                  path="/is-yeri-bilgilerim"
                  element={
                    <PrivateRoute
                      component={MyMerchs}
                      authorityCode={authorities.DISPLAY_ALL_RECORDS_MERHANT_INFO}
                    />
                  }
                />
                <Route
                  path="/kullanici-bilgileri"
                  element={
                    <PrivateRoute
                      component={UserInformation}
                      authorityCode={authorities.DISPLAY_INFORMATION_USER}
                    />
                  }
                />
                <Route
                  path="/is-yeri-bilgileri"
                  element={
                    <PrivateRoute
                      component={SubMerchs}
                      authorityCode={authorities.DISPLAY_ALL_RECORDS_MERHANT_INFO}
                    />
                  }
                />
                <Route
                  path="/is-yeri-bilgilerim/duzenle/:number"
                  element={
                    <PrivateRoute
                      component={MerchEdit}
                      authorityCode={authorities.UPDATE_MERHANT_INFO}
                    />
                  }
                />
                <Route
                  path="/subeler"
                  element={
                    <PrivateRoute
                      component={Branch}
                      authorityCode={authorities.DISPLAY_ALL_RECORDS_BRANCHS}
                    />
                  }
                />
                <Route
                  path="/sube-islemleri/edit"
                  element={
                    <PrivateRoute
                      component={BranchEdit}
                      authorityCode={authorities.UPDATE_BRANCH}
                    />
                  }
                />
                {/* <Route
                  path="/basvurular/yeni-sube-basvurusu"
                  element={
                    <PrivateRoute component={BranchAdd} authorityCode={authorities.APPLICATIONS} />
                  }
                /> */}
                {/* <Route
                  path="/basvurular/yeni-terminal-basvurusu"
                  element={
                    <PrivateRoute
                      component={TerminalAdd}
                      authorityCode={authorities.APPLICATIONS}
                    />
                  }
                /> */}
                {/* <Route
                  path="/basvurular/yeni-terminal-basvurusu/:branchId"
                  element={
                    <PrivateRoute
                      component={TerminalAdd}
                      authorityCode={authorities.APPLICATIONS}
                    />
                  }
                /> */}
                <Route
                  path="/terminal-bilgileri/:branchId"
                  element={
                    <PrivateRoute
                      component={Terminal}
                      authorityCode={authorities.DISPLAY_INFORMATION_TERMINAL}
                    />
                  }
                />
                <Route
                  path="/raporlar/sube-bazli-gun-sonu-raporu"
                  element={
                    <PrivateRoute
                      component={EodReportByMerch}
                      authorityCode={authorities.EOD_REPORT}
                    />
                  }
                />
                <Route
                  path="/raporlar/terminal-bazli-gun-sonu-raporu/:branchId/:terminalId"
                  element={
                    <PrivateRoute
                      component={EodReportByBranchWrapper}
                      authorityCode={authorities.EOD_REPORT}
                    />
                  }
                />
                <Route
                  path="/raporlar/islem-bazli-gun-sonu-raporu/:branchId/:terminalId"
                  element={
                    <PrivateRoute
                      component={EodReportByTerminalWrapper}
                      authorityCode={authorities.EOD_REPORT}
                    />
                  }
                />
                {/* <Route
                  path="/raporlar/cari-hesap-raporu"
                  element={
                    <PrivateRoute
                      component={CurrentAccount}
                      authorityCode={authorities.CURRENT_ACCOUNT_REPORT}
                    />
                  }
                /> */}
                {/* <Route
                  path="/raporlar/babs"
                  element={
                    <PrivateRoute component={Babs} authorityCode={authorities.BABS_REPORT} />
                  }
                /> */}
                <Route
                  path="/odemeler-ve-faturalar/tarafima-kesilen-faturalar"
                  element={
                    <PrivateRoute
                      component={MyInvoice}
                      authorityCode={authorities.INVOICE_REPORT}
                    />
                  }
                />
                <Route
                  path="/odemeler-ve-faturalar/paye-tarafindan-kesilen-faturalar"
                  element={
                    <PrivateRoute
                      component={PayeInvoice}
                      authorityCode={authorities.PAYE_INVOICE_REPORT}
                    />
                  }
                />
                <Route
                  path="/odemeler-ve-faturalar/faturaya-dahil-edilmeyen-islemler"
                  element={
                    <PrivateRoute
                      component={TransactionsNotIncludedInvoice}
                      authorityCode={authorities.PAYE_INVOICE_REPORT}
                    />
                  }
                />
                <Route
                  path="/odemeler-ve-faturalar/odemeler"
                  element={
                    <PrivateRoute component={Payment} authorityCode={authorities.PAYMENT_REPORT} />
                  }
                />
                <Route
                  path="/izinler"
                  element={
                    <PrivateRoute
                      component={Role}
                      authorityCode={authorities.DISPLAY_ALL_RECORDS_ROLE}
                    />
                  }
                />
                <Route
                  path="/duyurular"
                  element={
                    <PrivateRoute
                      component={Announcements}
                      authorityCode={authorities.DISPLAY_ALL_RECORDS_ANNOUNCEMENTS}
                    />
                  }
                />
                <Route path="*" element={<Navigate to="/login" />} />
              </Routes>
            </Router>
          </BranchProvider>
        </AnnouncementProvider>
      </ConfigProvider>
    );
  }
}

export default App;
